var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.dialogVisible),callback:function ($$v) {_vm.dialogVisible=$$v},expression:"dialogVisible"}},[_c('v-card',{staticClass:"pa-4"},[_c('SignInForm',{on:{"is-authenticated":_vm.onAuthenticated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }